module.exports = __webpack_public_path__ + "static/media/campus-platform-moduleB-icon7.f3aa5fe9.png";